module.exports = __webpack_public_path__ + "img/pic-3.bd3f3122.png";